import type { FeatureGroup } from '../../../types';
import { ADMINISTRATIVE_FEATURE_GROUP } from '../group';

export const API_KEYS_FEATURE_GROUP: FeatureGroup = {
  guid: 'e8a4b7c2-9d3f-4e1a-b6c5-2f7d8a9e0ff00',
  name: 'api_keys',
  description: 'API key management — create and manage API keys for organization authentication',
  product: 'account',
  parentGuid: ADMINISTRATIVE_FEATURE_GROUP.guid,
};
